export default __webpack_public_path__ + "static/media/brownArrowRight.32233ef1.svg";